import { ProcessItem } from './ProcessItem';

export class ProcessItemList {
    constructor(parentList: ProcessItem[]) {
        this.parentList = parentList;
    }
    parentList: ProcessItem[];
}
